import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaSpinner, FaInfoCircle } from "react-icons/fa";

import { useSettings } from '../context/SettingsContext';
import { Nav } from './partials/Nav';
import { API_URL } from './Constants';
import Loading from './partials/Loading';
import StatusKey from './partials/StatusKey';

const TransactionEdit = () => {
  const { transactionId } = useParams();
  const settings = useSettings();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [showClose, setShowClose] = useState(false);
  const [showTextBox, setShowTextBox] = useState(false);
  const [text, setText] = useState('');
  const [sendingMessage, setSendingMessage] = useState(false);
  const [closingDriver, setClosingDriver] = useState('');
  const [showStatusKey, setShowStatusKey] = useState(false)
  const [startingStall, setStartingStall] = useState('');

  const [transaction, setTransaction] = useState({
    key_tag: '',
    customer_name: '',
    customer_email: '',
    customer_phone: '',
    vehicle_color: '',
    vehicle_make: '',
    vehicle_plate: '',
    status: -1,
    stall_number: '',
    driver: '',
    time_created: '',
    time_closed: '',
    closing_driver: ''
  });

  useEffect(() => {
    if (!settings.userToken || !transactionId) {
      navigate('/');
      return;
    }

    var myHeaders = new Headers();
    myHeaders.append("vp-session-token", settings.userToken);

    var formdata = new FormData();
    formdata.append("id", transactionId);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(API_URL + "gettransaction", requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.code === 200) {
          setTransaction(result.transaction);
          setStartingStall(result.transaction.stall_number)
        } else {
          alert(result.message);
          navigate('/');
        }
        setLoading(false);
      })
      .catch(error => {
        console.log('error', error);
        alert('Error loading transaction');
        navigate('/');
      });
  }, [transactionId, settings.userToken]);

  const handleInputChange = (field, value) => {
    setTransaction(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = () => {
    setIsSaving(true);

    var myHeaders = new Headers();
    myHeaders.append("vp-session-token", settings.userToken);

    var formdata = new FormData();
    formdata.append("transaction_id", transactionId);
    formdata.append("key_tag", transaction.key_tag);
    formdata.append("customer_name", transaction.customer_name);
    formdata.append("customer_email", transaction.customer_email);
    formdata.append("customer_phone", transaction.customer_phone);
    formdata.append("vehicle_color", transaction.vehicle_color);
    formdata.append("vehicle_make", transaction.vehicle_make);
    formdata.append("vehicle_plate", transaction.vehicle_plate);
    formdata.append("status", transaction.status);
    formdata.append("stall_number", transaction.stall_number);
    formdata.append("driver", transaction.driver);
    formdata.append('lot', settings.selectedLot)

    if (startingStall !== transaction.stall_number) {
      formdata.append('event', 'park')
    } else if (transaction.status == 4) {
      formdata.append('event', 'pull')
    } else if (transaction.status == 0) {
      formdata.append('event', 'close')
    } else {
      formdata.append('event', 'update')
    }

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(API_URL + "addparking", requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.code === 200) {
          navigate('/');
        } else {
          alert(result.message);
        }
        setIsSaving(false);
      })
      .catch(error => {
        alert('There was an unexpected error. ' + error + ' Please try again.');
        setIsSaving(false);
      });
  };

  const sendMessage = () => {
    setSendingMessage(true);

    if (!text) {
      setSendingMessage(false);
      alert('A message is required. Please try again.');
      return;
    }

    var myHeaders = new Headers();
    myHeaders.append("vp-session-token", settings.userToken);

    var formdata = new FormData();
    formdata.append("id", transactionId);
    formdata.append("text", text);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(API_URL + "sendmessage", requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.code === 400) {
          alert(result.message);
        } else {
          setSendingMessage(false);
          setShowTextBox(false);
          setText('');
        }
      })
      .catch(error => console.log('error', error));
  };

  const closeParking = () => {
    if (!closingDriver) {
      alert('Driver name is required. Please try again.');
      return;
    }

    var myHeaders = new Headers();
    myHeaders.append("vp-session-token", settings.userToken);

    var formdata = new FormData();
    formdata.append("id", transactionId);
    formdata.append("closing_driver", closingDriver);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(API_URL + "closetransaction", requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.code === 400) {
          alert(result.message);
        } else {
          navigate('/');
        }
      })
      .catch(error => console.log('error', error));
  };

  if (loading) {
    return (
      <div className='min-h-screen'>
        <Nav back={true}>Edit Transaction</Nav>
        <Loading />
      </div>
    );
  }

  return (
    <div className='min-h-screen'>
      <Nav back={true}>Edit Transaction</Nav>
      
      <div className='flex-1 w-full py-12 mx-auto max-w-3xl'>
        <div className='p-5 w-full'>
          <div className='mb-8'>
            <h3 className='text-lg font-medium mb-4'>Transaction Status</h3>
            <select 
              className='block w-full border border-gray-300 rounded-md shadow-sm p-2'
              value={transaction.status}
              onChange={(e) => handleInputChange('status', e.target.value)}
            >
              <option value="-1">Select...</option>
              <option value="1">Open</option>
              <option value="2">Requested</option>
              <option value="3">Make Ready</option>
              <option value="4">Car Ready</option>
              <option value="0">Close</option>
            </select>
            
            <div className='flex justify-center items-center mt-6'>
              <button 
                onClick={() => setShowStatusKey(true)}
                className="py-1 px-2 bg-darkgrey rounded-3xl text-white text-sm font-bold uppercase hover:bg-accent transition-colors flex items-center gap-2"
              >
                <FaInfoCircle className="text-lg" /> <span>View Status Key</span>
              </button>
            </div>
          </div>

          <StatusKey isOpen={showStatusKey} onClose={() => setShowStatusKey(false)} />

          <div className='border-t border-solid border-primary mb-8 p-2 pt-5 mt-3'>
            <div className='mb-5'>
              <div className='md:text-lg text-base font-bold'>
                <div className='mb-4'>
                  <label className='block text-sm font-medium text-gray-700'>Space Number</label>
                  <input
                    type='text'
                    className='mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2'
                    value={transaction.stall_number}
                    onChange={(e) => handleInputChange('stall_number', e.target.value)}
                  />
                </div>
                <div className='mb-4'>
                  <label className='block text-sm font-medium text-gray-700'>Driver</label>
                  <input
                    type='text'
                    className='mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2'
                    value={transaction.driver}
                    onChange={(e) => handleInputChange('driver', e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className='mb-8'>
              <h3 className='text-lg font-medium mb-4'>Customer Information</h3>
              <div className='grid grid-cols-1 gap-4'>
                <div>
                  <label className='block text-sm font-medium text-gray-700'>Name</label>
                  <input
                    type='text'
                    className='mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2'
                    value={transaction.customer_name}
                    onChange={(e) => handleInputChange('customer_name', e.target.value)}
                  />
                </div>
                <div>
                  <label className='block text-sm font-medium text-gray-700'>Phone</label>
                  <input
                    type='text'
                    className='mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2'
                    value={transaction.customer_phone}
                    onChange={(e) => handleInputChange('customer_phone', e.target.value)}
                  />
                </div>
                <div>
                  <label className='block text-sm font-medium text-gray-700'>Email</label>
                  <input
                    type='text'
                    className='mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2'
                    value={transaction.customer_email}
                    onChange={(e) => handleInputChange('customer_email', e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className='mb-8'>
              <h3 className='text-lg font-medium mb-4'>Vehicle Information</h3>
              <div className='grid grid-cols-1 gap-4'>
                <div>
                  <label className='block text-sm font-medium text-gray-700'>Color</label>
                  <input
                    type='text'
                    className='mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2'
                    value={transaction.vehicle_color}
                    onChange={(e) => handleInputChange('vehicle_color', e.target.value)}
                  />
                </div>
                <div>
                  <label className='block text-sm font-medium text-gray-700'>Plate</label>
                  <input
                    type='text'
                    className='mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2'
                    value={transaction.vehicle_plate}
                    onChange={(e) => handleInputChange('vehicle_plate', e.target.value)}
                  />
                </div>
                <div>
                  <label className='block text-sm font-medium text-gray-700'>Make</label>
                  <input
                    type='text'
                    className='mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2'
                    value={transaction.vehicle_make}
                    onChange={(e) => handleInputChange('vehicle_make', e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className='flex gap-4 justify-center'>
              {transaction.customer_phone && transaction.status !== 0 && (
                <>
                  <button
                    onClick={() => setShowTextBox(!showTextBox)}
                    className='py-2 px-4 bg-darkgrey text-white rounded-xl hover:bg-accent transition-colors'
                  >
                    Send Message
                  </button>
                </>
              )}
            </div>

            {showTextBox && (
              <div className='mt-5 max-w-[450px] mx-auto'>
                <textarea
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  placeholder="Enter the message you need to send to the customer here."
                  className='block w-full border border-gray-300 rounded-md shadow-sm p-2 mb-4'
                  rows={4}
                />
                <button
                  onClick={sendMessage}
                  disabled={sendingMessage}
                  className='w-full py-2 px-4 bg-darkgrey text-white rounded-xl hover:bg-accent transition-colors'
                >
                  {sendingMessage ? (
                    <FaSpinner className='animate-spin mx-auto' />
                  ) : (
                    'Send Message'
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className='flex bg-primary w-full p-2 py-4 fixed bottom-0'>
        <div className='mx-auto max-w-3xl w-full flex'>
          {isSaving ? (
            <div className='flex items-center justify-center w-full py-2 px-4 bg-darkgrey rounded-3xl'>
              <FaSpinner className="text-white animate-spin" />
            </div>
          ) : (
            <button
              className='flex items-center justify-center w-full py-3 px-4 bg-darkgrey rounded-3xl'
              onClick={handleSave}
            >
              <span className='text-center text-white text-xl font-bold uppercase'>Save Changes</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TransactionEdit;
